import React from "react";

import styles from "./SettingsTable.css";

export default function SettingsTable({ children }) {
  return <div className={styles.root}>{children}</div>;
}
